import { createSlice } from "@reduxjs/toolkit";
import { fetchDashboard } from "./dashboardThunks";

const initialState = {
  isLoading: false,
  data: null,
};

export const dashboard = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    clearDashboard: {
      reducer(state) {
        state.isLoading = false;
        state.data = null;
      },
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboard.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchDashboard.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload;
      })
      .addCase(fetchDashboard.rejected, (state) => {
        state.isLoading = false;
        state.data = null;
      });
  },
});

export const { clearDashboard } = dashboard.actions;

export default dashboard.reducer;
